(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCartPage() {
      var page = document.querySelector('[data-jc-cart-page]');
      if (!page || page.dataset.ready) return;
      page.dataset.ready = 'true';
      var discount = page.querySelector('[data-jc-discount]');
      var form = page.querySelector('[data-jc-discount-form]');
      if (discount && form) {
        discount.hidden = false;
        var error = page.querySelector('[data-jc-discount-error]');
        if (window.location.hash === '#discount-not-applied') {
          error.hidden = false;
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var input = page.querySelector('#JcDiscount');
          var code = input.value.trim();
          if (!code) { input.focus(); return; }
          var button = page.querySelector('[data-jc-apply]');
          button.disabled = true;
          error.hidden = true;
          var controller = new AbortController();
          var timer = setTimeout(function () { controller.abort(); }, 8000);
          fetch(form.dataset.rootUrl + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin', signal: controller.signal,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code })
          }).then(function (response) {
            if (!response.ok) throw new Error('Discount update failed');
            return response.json();
          }).then(function (cart) {
            var applied = (cart.discount_codes || []).some(function (discountCode) {
              return discountCode.code.toLowerCase() === code.toLowerCase() && discountCode.applicable;
            });
            history.replaceState(null, '', form.dataset.cartUrl + (applied ? '' : '#discount-not-applied'));
            window.location.reload();
          }).catch(function () { error.hidden = false; })
            .finally(function () { clearTimeout(timer); button.disabled = false; });
        });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartPage);
    else initCartPage();
    document.addEventListener('shopify:section:load', initCartPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glass-skin-ritual"] && !Shopify.designMode) return;
  try {
    

function initGlassSkin(){document.querySelectorAll('.gs').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const toggles=[...root.querySelectorAll('.gs-toggle')];let active=null;function close(restore){if(!active)return;const old=active;document.getElementById(old.getAttribute('aria-controls')).hidden=true;old.setAttribute('aria-expanded','false');old.querySelector('[data-explore]').innerHTML=root.dataset.explore+' <span aria-hidden="true">＋</span>';active=null;if(restore)old.focus()}toggles.forEach(toggle=>toggle.addEventListener('click',()=>{const was=active===toggle;close(false);if(was)return;active=toggle;toggle.setAttribute('aria-expanded','true');toggle.querySelector('[data-explore]').innerHTML=root.dataset.close+' <span aria-hidden="true">−</span>';const panel=document.getElementById(toggle.getAttribute('aria-controls'));panel.hidden=false;requestAnimationFrame(()=>{const rect=panel.getBoundingClientRect();if(rect.top<0||rect.top>innerHeight*.7)panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'})})}));root.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>close(true)));root.addEventListener('keydown',e=>{if(e.key==='Escape'&&active){e.preventDefault();close(true)}})})}initGlassSkin();document.addEventListener('shopify:section:load',initGlassSkin);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-image-cycle"] && !Shopify.designMode) return;
  try {
    
  //console.log('hero image');
  var mobile_image = document.getElementById("mobile-image");
  var desktop_small_image = document.getElementById("desktop-small-image");
  var desktop_large_image = document.getElementById("desktop-large-image");
  var i = 0;
  function volgendefoto() {
      i<mobile_images.length-1?i+=1:i=0;
      mobile_image.srcset=mobile_images[i];
      desktop_small_image.srcset=desktop_small_images[i];  
      desktop_large_image.srcset=desktop_large_images[i];  
      //console.log('Changed mobile image to: '+mobile_images[i])                          
  }
  setInterval(volgendefoto, 5000);
  var preloadimg=new Image();                             
  if(window.matchMedia("(max-width: 720px)").matches){  
    preloadimg.src=mobile_images[0];  
    //console.log('Preloading image: '+mobile_images[0]);                        
  }else if(window.matchMedia("(min-width:721px) and (max-width:1500px)").matches){
  	preloadimg.src=desktop_small_images[0]; 
  }else if(window.matchMedia("(min-width:1501px)").matches){
  	preloadimg.src=desktop_large_images[0]; 
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-image-mobile-cycle"] && !Shopify.designMode) return;
  try {
    
  //console.log('hero image');
  var mobile_image = document.getElementById("mobile-image");
  var i = 0;
  function volgendefoto() {
      i<mobile_images.length-1?i+=1:i=0;
      mobile_image.srcset=mobile_images[i];
      //console.log('Changed mobile image to: '+mobile_images[i])                          
  }
  setInterval(volgendefoto, 5000); 
  if(window.matchMedia("(max-width: 720px)").matches){
    var preloadimg=new Image();
    preloadimg.src=mobile_images[0];  
    //console.log('Preloading image: '+mobile_images[0]);                           
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-unified"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    document.querySelectorAll('.hero-unified').forEach(function (hero) {
      var slides  = Array.prototype.slice.call(hero.querySelectorAll('.hero-slide'));
      var speed   = parseInt(hero.dataset.speed || '5', 10) * 1000;
      var current = 0;
      var timer = null;

      function activeVideo(slide) {
        if (!slide) return null;

        var mobile = window.matchMedia('(max-width: 749px)').matches;
        var selector = mobile
          ? '.hero-unified__media-wrapper--mobile video'
          : '.hero-unified__media-wrapper--desktop video';

        return slide.querySelector(selector) || slide.querySelector('video');
      }

      function restartActiveSlide() {
        if (slides.length > 1) {
          scheduleNext();
          return;
        }

        var video = activeVideo(slides[current]);
        if (!video) return;

        video.currentTime = 0;
        video.play().catch(function () {});
      }

      window.addEventListener('pageshow', function () {
        window.setTimeout(restartActiveSlide, 0);
      });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) window.setTimeout(restartActiveSlide, 0);
      });

      if (slides.length <= 1) return;

      function showNext() {
        var previousVideo = activeVideo(slides[current]);
        if (previousVideo) previousVideo.pause();

        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
        scheduleNext();
      }

      function scheduleNext() {
        clearTimeout(timer);
        var video = activeVideo(slides[current]);

        if (!video) {
          timer = setTimeout(showNext, speed);
          return;
        }

        video.loop = false;
        video.currentTime = 0;
        video.addEventListener('ended', showNext, { once: true });
        video.play().catch(function () {
          timer = setTimeout(showNext, speed);
        });
      }

      scheduleNext();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
